module.exports = __webpack_public_path__ + "img/编组 10@2x.cacf34ad.png";